import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PaymentService } from '../../../../services/payment.service';
import { PurchaseOrder } from '../../../../model/purchase-order';
import { Product, ProductLineItem, StripePaymentRequest } from '../../../../model/stripe-payment-request.model';
import { Rodeo } from '../../../../model/rodeo';
import { AccountHelper } from '../../../../lib/accountHelper';
import { RodeoEventRegistration } from '../../../../model/rodeoEventRegistration';
import { NavController } from 'ionic-angular';

@Component({
    selector: 'app-purchase-order',
    templateUrl: 'purchase-order.component.html'
})
export class PurchaseOrderComponent implements OnChanges {
    @Input() orderId: number;
    @Input() rodeo: Rodeo;
    @Input() registration: RodeoEventRegistration;
    displayRequest: StripePaymentRequest;
    order: PurchaseOrder;
    isLoading = false;
    products: Product[] = [];
    riderIds: number[];
    showOrderInfo = false;
    paymentMethod: 'stripe' | 'check' | 'cash' = "stripe";

    constructor(
        private paymentService: PaymentService,
        private nav: NavController
    ) { }

    async ngOnInit() {
        this.isLoading = true;
        this.products = await this.paymentService.getProducts();
        this.displayRequest = this.formatRequest();

        if (this.rodeo && this.rodeo.organization) {
            this.riderIds = this.displayRequest.accountIds;
            // console.log('riderIds: ', this.riderIds);
        }
        this.isLoading = false;
    }

    async updateRegistration() {
        this.getRegistrationPaymentInfo(this.registration);
     }

    async ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
        if (changes.orderId && changes.orderId.currentValue > 0) {
            await this.getOrder();
            this.displayRequest = this.formatRequest();
        } else if (changes.registration) {
            //update request
            if (this.registration.purchaseOrderId) {
                await this.getOrder();
                this.displayRequest = this.formatRequest();                    
            } else {
                this.order = undefined;
                this.paymentMethod = !this.rodeo.secretary ? 'cash' : 'stripe';
                this.getRegistrationPaymentInfo(this.registration);
            }
        }
    }

    async getOrder() {
        this.isLoading = true;
        try {
            this.order = await this.paymentService.getOrder(this.orderId);
            this.paymentMethod = this.order.paymentMethod;
        } finally {
            this.isLoading = false;
        }
    }

    async getRegistrationPaymentInfo(registration: RodeoEventRegistration) {
        this.isLoading = true;
        try {
            this.displayRequest = await this.paymentService.getPaymentInformation(registration, this.paymentMethod);
            console.log('getRegistrationPaymentInfo');
        } finally {
            this.isLoading = false;
        }
    }

    async goToPaymentBeta(print = false) {
        const link = document.createElement('a');
        const token = encodeURIComponent(JSON.stringify(AccountHelper.instance().token));
        console.log(token);
        let url = 'https://nextgendemo.z19.web.core.windows.net/payments/orders/' + this.orderId + '?rodeoId=' + this.rodeo.id + '&token=' + token;
        if (print) {
            url += '&print=true';
        }
        link.href = url;
        link.target = '_blank';

        link.click();        
    }

    formatRequest() {
        const products = [];
        if (this.order) {
            products.push(...this.configureProductsForOrder());
        }

        const request = {
            products,
            isTestPayment: this.order ? this.order.isTest : this.rodeo.test,
            accountId: this.order ? this.order.accountId : undefined,
            accountIds: this.registration.contestantTwoId ? [this.registration.contestantOneId, this.registration.contestantTwoId] : [this.registration.contestantOneId],
            rodeoId: this.order ? this.order.rodeoId : this.rodeo.id,
            secretaryId: this.order ? this.order.secretaryId : this.rodeo.secretary ? this.rodeo.secretary.id : undefined,
            subtotal: this.order ? this.order.subtotal * 100 : 0,
            feeTotal: this.order ? this.order.feesTotal * 100 : 0,
            total: this.order ? this.order.totalCharged * 100 : 0,
            paymentMethod: this.order ? this.order.paymentMethod : this.paymentMethod
        };
        console.log('PAY REQUEST', request);
        return request;
    }

    private configureProductsForOrder() {
        const products = [];

        this.order.lineItems.forEach(lineItem => {
            //dont show the app fee in the product array
            if (lineItem.displayName && !lineItem.displayName.includes('Non-Ref CC Admin Fee')) {
                const product: ProductLineItem = {
                    productId: lineItem.productId,
                    quantity: lineItem.quantity,
                    entityIds: lineItem.entityIds ? lineItem.entityIds.split(',').map(x => Number(x)) : [],
                    productType: lineItem.productType,
                    displayName: lineItem.displayName,
                    amount: lineItem.totalPrice,
                    amountComped: lineItem.amountComped
                };
                products.push(product);
            }
        });

        return products;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/purchase-order/purchase-order.component.ts